module.exports = __webpack_public_path__ + "img/codes_of_law.485a3413.png";